import { gsap, ScrollTrigger } from "gsap/all";

gsap.registerPlugin(ScrollTrigger);

export const onRouteUpdate = () => {
  ScrollTrigger.getAll().forEach(t => t.kill());
  ScrollTrigger.clearMatchMedia();
}